import { size as _size } from 'lodash-es';
import { dbEvents } from 'dbServer/collections';

export const fetchSessionDetails = async eventId => {
	const sessionData = await dbEvents.getSessionDetails(eventId);
	return !_size(sessionData) ? {} : sessionData;
};
